import React, { useState } from "react";
import { Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { AppstoreOutlined } from "@ant-design/icons";
import drawerHeader from "../../assets/images/logoLogin.png";
import { getMenuGroups } from "./menuConfig";
import "../../assets/styles/Sidenav.css";

function Sidenav({ color, onClick }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [openKeys, setOpenKeys] = useState([]);

  // จัดการการเปิด-ปิด Submenu
  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  // key ของเมนู -> ข้อมูลเมนู (ใช้ตอนคลิก และหาเมนูที่ถูกเลือก)
  const itemByKey = {};

  // แปลงรายการเมนูจาก menuConfig ให้อยู่ในรูปแบบ items ของ antd Menu (กรองตามสิทธิ์ show)
  const toMenuItems = (items, keyPrefix) =>
    items
      .filter((item) => item.show)
      .map((item) => {
        const key = `${keyPrefix}>${item.label}`;
        itemByKey[key] = item;
        return { key, icon: item.icon, label: item.label };
      });

  const groupItems = getMenuGroups()
    .filter((group) => group.show)
    .map((group) => {
      const children = group.subGroups
        ? group.subGroups
            .map((sub) => ({
              type: "group",
              key: `${group.groupTitle}>${sub.subTitle}`,
              label: sub.subTitle,
              children: toMenuItems(
                sub.items,
                `${group.groupTitle}>${sub.subTitle}`,
              ),
            }))
            .filter((sub) => sub.children.length > 0)
        : toMenuItems(group.items, group.groupTitle);

      return {
        key: group.groupTitle,
        icon: group.groupIcon,
        label: group.groupTitle,
        children,
      };
    })
    .filter((group) => group.children.length > 0);

  const menuItems = [
    {
      key: "หน้าแรก",
      icon: <AppstoreOutlined />,
      label: "หน้าแรก",
    },
    ...groupItems,
  ];

  const selectedKeys = Object.keys(itemByKey).filter(
    (key) => itemByKey[key].path === pathname,
  );
  if (pathname === "/") selectedKeys.push("หน้าแรก");

  const handleMenuClick = ({ key }) => {
    if (key === "หน้าแรก") {
      if (onClick) onClick("หน้าแรก");
      navigate("/");
      return;
    }
    const item = itemByKey[key];
    if (!item) return;
    if (onClick) onClick(item.label); // ส่งชื่อไปที่ Header เหมือน MenuDashboard
    navigate(item.path);
  };

  return (
    <div className="sidenav-container">
      <div className="brand-logo">
        <img src={drawerHeader} alt="One Leasing" />
      </div>

      <Menu
        mode="inline"
        theme="light"
        items={menuItems}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
        selectedKeys={selectedKeys}
        className="main-menu-style"
        onClick={handleMenuClick}
      />
    </div>
  );
}

export default Sidenav;
